import { ROTATE_REQUEST_PARTNO_LIST, NO_ROTATES_NEEDED_CB, ROTATES, ROTATE_REQUEST, ROTATES_OUT_OF_STOCK} from '../actions/actionTypes';

const initialState = {
    items_rotateRequestState: [0],
    items_rotatesState: [],
    items_rotateInvoiceOutOfStockBatteryState: [],
    validRotatesPartno: false,
    noRotatesNeededCbState: false,
    items_rotateRequestPartnoList: [],
}

const rotatesReducer = (state = initialState, action) => {
    switch(action.type){ 
        case ROTATE_REQUEST:
            // console.log('rotatesReducer rotatesReducer ROTATE_REQUEST  action.payload: ',  action.payload); 

            return {
                ...state,
                items_rotateRequestState: action.payload,
            }    
        case ROTATES:
            // console.log('rotatesReducer rotatesReducer ROTATES action.payload: ',  action.payload); 
            return {
                ...state,
               items_rotatesState: action.payload,
            }     
        case ROTATES_OUT_OF_STOCK:
            // console.log('rotatesReducer rotatesReducer ROTATES_OUT_OF_STOCK action.payload: ',  action.payload); 
            return {
                ...state,
                items_rotateInvoiceOutOfStockBatteryState: action.payload
            }    
        case NO_ROTATES_NEEDED_CB:
            return {
                ...state,
                noRotatesNeededCbState: action.payload
            }   
        case ROTATE_REQUEST_PARTNO_LIST:
            return {
                ...state,
                items_rotateRequestPartnoList: action.payload
            }
        default:
            return state;
    }
}

export { rotatesReducer };